import { ReactElement } from 'react'

import classNames from 'classnames'

import * as styles from './styles.scss'

interface Props {
    /**
     * By default, the component used for table titles is an `<h2 />`.
     * In cases where the table is the only item on the page, set the `component` prop to 'h1'
     */
    component?: 'h1' | 'h2'
    /**
     * Text of the table's title
     */
    titleText: string
    /**
     * Additional CSS classes to apply to the component
     */
    className?: string
}

export default function TableTitle({
    component = 'h2',
    titleText,
    className,
}: Props): ReactElement {
    return component === 'h1' ? (
        <h1 className={classNames(styles['main-heading'], className)}>
            {titleText}
        </h1>
    ) : (
        <h2 className={classNames(styles['secondary-heading'], className)}>
            {titleText}
        </h2>
    )
}
